var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3D5FCD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M869.2,869.2H130.8C63,869.2,7.8,814,7.8,746.1V253.9C7.8,186,63,130.8,130.8,130.8h738.3 c67.9,0,123.1,55.2,123.1,123.1v492.2C992.2,814,937,869.2,869.2,869.2z M130.8,212.9c-22.6,0-41,18.4-41,41v492.2 c0,22.6,18.4,41,41,41h738.3c22.6,0,41-18.4,41-41V253.9c0-22.6-18.4-41-41-41H130.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M951.2,459H48.8c-22.7,0-41-18.4-41-41c0-22.7,18.4-41,41-41h902.4c22.7,0,41,18.4,41,41 C992.2,440.6,973.9,459,951.2,459z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBlue);
export default __webpack_public_path__ + "static/media/wallet-blue.c111bd7b3046069724254e6e6c3e418c.svg";
export { ForwardRef as ReactComponent };